import { SNACKBAR_ADD_MESSAGE, SNACKBAR_REMOVE_MESSAGE } from "../constants";

export default (state = [], action) => {
  const newState = [...state];

  switch (action.type) {
    case SNACKBAR_ADD_MESSAGE:
      newState.push(action.message);
      return newState;
    case SNACKBAR_REMOVE_MESSAGE:
      return newState.filter((message) => message.id !== action.messageId);
    default:
      return newState;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/snackbar.js